const COLORS = ['#b6f421', '#80bdb8', '#6a5fec', '#d46b8c', '#cf23ee', '#02bd02']
const SUITS = ['h', 'd', 's', 'c']
const RANKS = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2']
const WEIGHT_OPT = ['None', 'Normalized', 'Absolute']

const COMBOS = [
	'str. flush',
	'quads',
	'flush',
	'full house',
	'straight',
	'set',
	'trips',
	'two pair',
	'overpair',
	'top pair',
	'under pair',
	'2-nd pair',
	'3-rd pair',
	'weak pair',
	'A-high',
	'K-high',
	'nothing',
]

const DRAWS = ['combo draw', 'flush draw', 'OESD', 'gutshot', 'BD_FD', 'BD_SD', 'BD_FD_SD', 'no draw']

const COMBOS_HAND_LINE = [
	'str. flush',
	'quads',
	'full house',
	'flush',
	'straight',
	'set',
	'trips',
	'two pair',
	'overpair',
	'top pair',
	'under pair',
	'2-nd pair',
	'3-rd pair',
	'weak pair',
	'A-high',
	'K-high',
	'nothing',
]

export default { COLORS, COMBOS, COMBOS_HAND_LINE, DRAWS, SUITS, WEIGHT_OPT, RANKS }
